import { View } from "react-native";
import { MetaText, StatusBadge } from "@louise/moon-ui";
import { useTranslations } from "@src/packages/i18n";

export default function SupplementOrderingNote() {
  const t = useTranslations();
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        marginTop: 8,
      }}
    >
      <StatusBadge type="coming-soon" />
      <MetaText style={{ marginTop: 0 }}>
        {t("supplement_ordering.in_app_ordering")}
      </MetaText>
    </View>
  );
}
